module.exports = __webpack_public_path__ + "static/media/logo_l.3650e58e.png";